import script from "./Servers.vue?vue&type=script&setup=true&lang=js"
export * from "./Servers.vue?vue&type=script&setup=true&lang=js"

import "./Servers.vue?vue&type=style&index=0&id=533b7e8e&lang=scss&scoped=true"

import exportComponent from "/opt/streamify/admin/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-533b7e8e"]])

export default __exports__